<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <div class="bg-inner cart-section order-details-table">
            <div class="row g-4">
              <div class="col-xl-8">
                <order_detail_table :items="orderedItems" />
              </div>

              <div class="col-xl-4">
                <order_summary :order="orderedItems.orderDetails" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import order_detail_table from '@/components/application/orders/order_detail/order_detail_table.vue';
import order_summary from '@/components/application/orders/order_detail/order_summary.vue';
import OrderDetail from '@/data/orderDetail.json';

const orderedItems = ref(OrderDetail.data);
</script>

<style></style>
